import React from 'react';

const EducationFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.06445 8.96777V14.7059C5.06445 14.7059 6.10961 17.0968 10.2903 17.0968C14.4709 17.0968 15.5161 14.7059 15.5161 14.7059V8.96777"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2903 2L1.89443 6.19795C1.5259 6.38221 1.5259 6.90811 1.89443 7.09237L10.2903 11.2903L18.1728 7.08634C18.5257 6.8981 18.5257 6.39222 18.1728 6.20398L10.2903 2Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.16211 7.8064V13.0322" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default EducationFilterIcon;
